import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notificationCheck'
})
export class NotificationTypeCheckPipe implements PipeTransform {

  transform(value: any): any {
    if(value == null || value == ''){
        return value
    }

    switch (value) {
      case 'bi bi-radioactive':
          return 'Critical'

      case 'bi bi-x-circle-fill':
          return 'Error'

      case 'bi bi-info-circle-fill':
          return 'Informative'

      case 'bi bi-exclamation-triangle-fill':
          return 'Warning'

      case 0:
        return 'Critical'

      case 1:
          return 'Error'

      case 2:
          return 'Informative'

      case 3:
          return 'Warning'
      default:
          return 'None'
      }
  }

}
